import axios from '../plugins/axios'

export default {
  switch_pin({ domain }) {
    return axios.post('/api/v1/tag_domains/change_domain', {
      domain: domain
    });
  },
  toggle_invalid({ tag_domain_id, is_invalid }) {
    return axios.post('/api/v1/tag_domains/toggle_invalid', {
      tag_domain_id: tag_domain_id,
      is_invalid: is_invalid
    });
  }
};